import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ContactDetail.scss';
import Button from '../../atoms/Button/Button';
// import { useDispatch } from 'react-redux';
// import { logUserAction } from '../../../api/actions/details-actions';
// import { useLocation } from 'react-router-dom';

const ContactDetail = ({ people, handleSubmitQuery, firstName, middleName, lastName }) => {
  const [toggleRelative, setToggleRelative] = useState(true);
  const [toggleAssociate, setToggleAssociate] = useState(true);
  const [toggleAddress, setToggleAddress] = useState(true);
  const [toggleAKA, setToggleAKA] = useState(true);
  const [toggleEmail, setToggleEmail] = useState(true);
  const [togglePhone, setTogglePhone] = useState(true);
  const [toggleMobile, setToggleMobile] = useState(true);
  const [toggleCity, setToggleCity] = useState(true);

  // const state = useLocation().state;

  const mobileNumbers = people?.phoneNumbers?.filter((number) => number.phoneType === 'Wireless');

  const otherNumbers = people?.phoneNumbers?.filter((number) => number.phoneType !== 'Wireless');

  const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
  const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;

  // const dispatch = useDispatch();

  // const logAction = (contactType, contactDetail, contactTitle) => {
  //   const action =
  //     contactType === 'email'
  //       ? 'FINDANYONE_EMAILED'
  //       : contactType === 'phone'
  //       ? 'FINDANYONE_CALLED'
  //       : 'FINDANYONE_CLICKED';
  //   dispatch(
  //     logUserAction('', action, '', '', '', '', '', '', '', '', {
  //       contact_title: contactTitle,
  //       contact_type: contactType,
  //       contact_detail: contactDetail,
  //       firstname: firstName,
  //       middlename: middleName,
  //       lastname: lastName,
  //       ...state
  //     })
  //   );
  // };

  return (
    <div className="tmx-contactDetail">
      <div className="tmx-contactDetail__header">
        <div className="tmx-contactDetail__name">{people?.fullName}</div>
        <div className="tmx-contactDetail__ageAndAddress">
          <div className="tmx-contactDetail__age">
            {people?.age} Years Old {people?.addresses[0]?.fullAddress}{' '}
            {people?.addresses[0]?.county} County ({people?.addresses[0]?.totalFirstSeenDate} -{' '}
            {people?.addresses[0]?.lastReportedDate})
          </div>
        </div>
      </div>
      <div className="tmx-contactDetail__body">
        <div className="tmx-contactDetail__bodyDetails">
          <div className="tmx-contactDetail__bodyDetail">
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Associated Names</div>
              {people?.akas?.map((aka, index) => (
                <div
                  className={classNames('tmx-contactDetail__content', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleAKA
                  })}
                  key={index}>
                  {aka?.firstName} {aka?.middleName} {aka?.lastName}
                </div>
              ))}
              {people?.akas?.length > 5 && (
                <Button
                  handleClick={() => setToggleAKA(!toggleAKA)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleAKA ? 'Show' : 'Hide'} {people?.akas?.length - 5} Associated Names
                </Button>
              )}
            </div>
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Other DOB’s</div>
              <div className="tmx-contactDetail__content">{people?.dob}</div>
            </div>
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Email Addresses</div>
              {people?.emailAddresses?.map((address, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__content', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleEmail
                  })}
                  onClick={() => {
                    // logAction('email', address?.emailAddress);
                  }}
                  onKeyDown={() => {
                    // logAction('email', address?.emailAddress);
                  }}
                  role="button"
                  tabIndex={0}>
                  <a
                    href={`mailto:${address.emailAddress}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tmx-contactDetail__linkContent">
                    {address?.emailAddress}
                  </a>
                </div>
              ))}
              {people?.emailAddresses?.length > 5 && (
                <Button
                  handleClick={() => setToggleEmail(!toggleEmail)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleEmail ? 'Show' : 'Hide'} {people?.emailAddresses?.length - 5} other email
                  addresses
                </Button>
              )}
            </div>
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Mobile Numbers</div>
              {mobileNumbers?.map((number, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__numberWrapper', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleMobile
                  })}
                  onClick={() => {
                    // logAction('phone', number?.phoneNumber);
                  }}
                  onKeyDown={() => {
                    // logAction('phone', number?.phoneNumber);
                  }}
                  role="button"
                  tabIndex={0}>
                  <a
                    href={`tel:+1${number.phoneNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tmx-contactDetail__linkContent">
                    {number?.phoneNumber}
                  </a>
                  <div className="tmx-contactDetail__content">{number?.company}</div>
                  <div className="tmx-contactDetail__content">
                    ({number?.totalFirstSeenDate} - {number.lastReportedDate})
                  </div>
                </div>
              ))}
              {mobileNumbers?.length > 5 && (
                <Button
                  handleClick={() => setToggleMobile(!toggleMobile)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleMobile ? 'Show' : 'Hide'} {mobileNumbers?.length - 5} other mobile numbers
                </Button>
              )}
            </div>
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Phone Numbers</div>
              {otherNumbers?.map((number, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__numberWrapper', {
                    'tmx-contactDetail__hideRelative': index > 4 && togglePhone
                  })}
                  onClick={() => {
                    // logAction('phone', number?.phoneNumber);
                  }}
                  onKeyDown={() => {
                    // logAction('phone', number?.phoneNumber);
                  }}
                  role="button"
                  tabIndex={0}>
                  <a
                    href={`tel:+1${number.phoneNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tmx-contactDetail__linkContent">
                    {number?.phoneNumber}
                  </a>
                  <div className="tmx-contactDetail__content">{number?.company}</div>
                  <div className="tmx-contactDetail__content">
                    ({number?.totalFirstSeenDate} - {number.lastReportedDate})
                  </div>
                </div>
              ))}
              {otherNumbers?.length > 5 && (
                <Button
                  handleClick={() => setTogglePhone(!togglePhone)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {togglePhone ? 'Show' : 'Hide'} {otherNumbers?.length - 5} other phone numbers
                </Button>
              )}
            </div>
          </div>
          <div className="tmx-contactDetail__bodyDetail">
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Possible Relatives</div>
              {people?.relativesSummary?.map((relative, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__contentWrapper', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleRelative
                  })}
                  onClick={() => {
                    // logAction(
                    //   'Possible Relative',
                    //   `${relative.firstName} ${relative.middleName} ${relative.lastName}`
                    // );
                  }}
                  onKeyDown={() => {
                    // logAction(
                    //   'Possible Relative',
                    //   `${relative.firstName} ${relative.middleName} ${relative.lastName}`
                    // );
                  }}
                  role="button"
                  tabIndex={0}>
                  <div className="tmx-contactDetail__innerContentWrapper">
                    <div className="tmx-contactDetail__innerContentWrapperDetails">
                      <div
                        className="tmx-contactDetail__linkContent"
                        onClick={() =>
                          handleSubmitQuery({
                            tahoeId: relative.tahoeId,
                            page: { current: 1, size: 20 },
                            email: isEmailPresent,
                            token: isTokenPresent
                          })
                        }
                        onKeyDown={() =>
                          handleSubmitQuery({
                            tahoeId: relative.tahoeId,
                            page: { current: 1, size: 20 },
                            email: isEmailPresent,
                            token: isTokenPresent
                          })
                        }
                        tabIndex={0}
                        role="button">
                        {relative.firstName} {relative.middleName} {relative.lastName}
                      </div>
                      <div className="tmx-contactDetail__content">DOB: {relative.dob}</div>
                    </div>
                  </div>
                </div>
              ))}
              {people?.relativesSummary?.length > 5 && (
                <Button
                  handleClick={() => setToggleRelative(!toggleRelative)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleRelative ? 'Show' : 'Hide'} {people?.relativesSummary?.length - 5} other
                  possible relatives
                </Button>
              )}
            </div>
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Possible Associates</div>
              {people?.associatesSummary?.map((associate, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__contentWrapper', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleAssociate
                  })}
                  onClick={() => {
                    // logAction(
                    //   'Possible Associate',
                    //   `${associate.firstName} ${associate.middleName} ${associate.lastName}`
                    // );
                  }}
                  onKeyDown={() => {
                    // logAction(
                    //   'Possible Associate',
                    //   `${associate.firstName} ${associate.middleName} ${associate.lastName}`
                    // );
                  }}
                  role="button"
                  tabIndex={0}>
                  <div className="tmx-contactDetail__innerContentWrapper">
                    <div className="tmx-contactDetail__innerContentWrapperDetails">
                      <div
                        className="tmx-contactDetail__linkContent"
                        onClick={() =>
                          handleSubmitQuery({
                            tahoeId: associate.tahoeId,
                            page: { current: 1, size: 20 },
                            email: isEmailPresent,
                            token: isTokenPresent
                          })
                        }
                        onKeyDown={() =>
                          handleSubmitQuery({
                            tahoeId: associate.tahoeId,
                            page: { current: 1, size: 20 },
                            email: isEmailPresent,
                            token: isTokenPresent
                          })
                        }
                        tabIndex={0}
                        role="button">
                        {associate.firstName} {associate.middleName} {associate.lastName}
                      </div>
                      <div className="tmx-contactDetail__content">DOB: {associate.dob}</div>
                    </div>
                  </div>
                </div>
              ))}
              {people?.associatesSummary?.length > 5 && (
                <Button
                  handleClick={() => setToggleAssociate(!toggleAssociate)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleAssociate ? 'Show' : 'Hide'} {people?.associatesSummary?.length - 5} other
                  possible associates
                </Button>
              )}
            </div>
          </div>
          <div className="tmx-contactDetail__bodyDetail">
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Cities</div>

              {people?.locations?.map((location, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__content', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleCity
                  })}>
                  {location?.city}, {location?.state}
                </div>
              ))}
              {people?.locations?.length > 5 && (
                <Button
                  handleClick={() => setToggleCity(!toggleCity)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleCity ? 'Show' : 'Hide'} {people?.locations?.length - 5} other cities
                </Button>
              )}
            </div>
          </div>
          <div className="tmx-contactDetail__bodyDetail">
            <div className="tmx-contactDetail__wrapper">
              <div className="tmx-contactDetail__title">Address History</div>
              {people?.addresses?.map((add, index) => (
                <div
                  key={index}
                  className={classNames('tmx-contactDetail__contentWrapper', {
                    'tmx-contactDetail__hideRelative': index > 4 && toggleAddress
                  })}>
                  <div className="tmx-contactDetail__content">{add.fullAddress}</div>
                  <div className="tmx-contactDetail__content">{add.county} County</div>
                  <div className="tmx-contactDetail__content">
                    ({add?.totalFirstSeenDate} - {add?.lastReportedDate})
                  </div>
                  <div className="tmx-contactDetail__contentWrapper--line"></div>
                </div>
              ))}
              {people?.addresses?.length > 5 && (
                <Button
                  handleClick={() => setToggleAddress(!toggleAddress)}
                  className={'tmx-contactDetail__toggleBtn'}>
                  {toggleAddress ? 'Show' : 'Hide'} {people?.addresses?.length - 5} other address
                  history
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ContactDetail.propTypes = {
  people: PropTypes.object,
  handleSubmitQuery: PropTypes.func,
  firstName: PropTypes.string,
  middleName: PropTypes.string,
  lastName: PropTypes.string
};

export default ContactDetail;
